import React, {useEffect, useState} from 'react';
import IconButton from '@material-ui/core/IconButton';
import {useSelector} from 'react-redux';
import Button from '@material-ui/core/Button';
import contactsData from './contactList';
import ContactListAgent from '../../../../../components/contact/ContactList/indexagent';
import {getagent, saveagent, deleteagent, editagent} from '../../../../../api/api.js' ;

// import AddContact from '../../../../../components/contact/AddContact';
import DialogClose from '../../../../../../src/util/DialogClose.js';
import {makeStyles} from '@material-ui/core/styles';
import IntlMessages from '../../../../../util/IntlMessages';
import CustomScrollbars from '../../../../../util/CustomScrollbars';
import TextField from '@material-ui/core/TextField';
import DialogContent from '@material-ui/core/DialogContent';
import Dialog from '@material-ui/core/Dialog';
import CircularProgress from '@material-ui/core/CircularProgress';
import {blue, green, purple} from "@material-ui/core/colors";
import CloseIcon from '@material-ui/icons/Close';
import Snackbar from '@material-ui/core/Snackbar';
import Alert from '@material-ui/lab/Alert';


let contactId = 723812738;
let listcontact = [];
let deletedata;

const filterOptions = [
    {
        id: 1,
        name: 'All contacts',
        icon: 'zmdi-menu'
    }, {
        id: 2,
        name: 'Frequently contacted',
        icon: 'zmdi-time-restore'

    }, {

        id: 3,
        name: 'Starred contacts',
        icon: 'zmdi-star'
    }
];


const useStyles = makeStyles((theme) => ({
    root: {
        fontFamily: 'iransans',
        padding: '20px 10px',
        '& .MuiTextField-root': {
            width: '100%',
            fontFamily: 'iransans',
        },
        '& .MuiAlert-message': {

            fontFamily: 'iransans',
        },


        '& .MuiFormHelperText-root': {

            fontFamily: 'iransans',
            marginTop: 5,
            marginLeft: 0


        },


        '& .MuiTypography-root': {

            fontFamily: 'iransans',
        },

        '& .MuiListItemText-secondary': {

            fontFamily: 'iransans',
            marginTop: 10,
        },

        '& .MuiTypography-body1': {

            fontFamily: 'iransans',

        },


        '& .MuiTypography-h6': {

            fontFamily: 'iransans',

        },
        '& .MuiButton-root': {

            fontFamily: 'iransans',

        },
        '& .MuiTypography-colorTextSecondary': {
            color: '#222'
        }
        // '& .MuiListItem-button': {
        //
        //     fontFamily: 'iransans',
        //    border:'1px solid #dadada',
        //   borderRadius: 4,
        //
        // },

    },

    avatar: {
        backgroundColor: blue[100],
        color: blue[600],
    },
    red: {

        color: '#f44336',


    },

    underlinetext: {

        fontSize: '0.75rem',
        marginTop: 5,
        color: '#f44336',
        fontFamily: 'iransans',


    },


    borderred: {
        fontFamily: 'iransans',
        border: '1px solid #f44336',
        borderRadius: 4,
        fontSize: 5,


    },
    border: {
        fontFamily: 'iransans',
        border: '1px solid rgba(0, 0, 0, 0.23)',
        borderRadius: 4,
        fontSize: 5,
        marginBottom: 0,
        height: 50,
        width: '100%',
        paddingLeft: 10,
        paddingRight: 10,
        display: 'flex',
        flexDirection: 'row-reverse',
        alignItems: 'center',
        color: 'rgba(0, 0, 0, 0.54)',


    },


    paper: {
        width: '80%',
        maxHeight: 435,
    },

    sendpic: {
        margin: '0 auto',
        marginBottom: 15,
        textAlign: 'center',
        '&:hover': {
            cursor: 'pointer',
        },
    },

    button: {
        fontSize: 15,
        fontWeight: 'bold',
        height: 40,
        width: 200,
        fontFamily: 'iransans',
        color: '#dadada',
          backgroundColor:'#3f51b5',
        '&:hover': {
             backgroundColor: '#172b95',
        },
    },
    buttonfull: {
        fontSize: 15,
        fontWeight: 'bold',
        height: 40,
        width: '100%',
        fontFamily: 'iransans',
        color: '#dadada',
          backgroundColor:'#3f51b5',
        '&:hover': {
             backgroundColor: '#172b95',
        },
    },

    input2: {
        fontFamily: 'iransans',
        width: '100%'
    },
    input: {
        fontFamily: 'iransans',
        width: '100%',

    },
    input3: {
        fontFamily: 'iransans',
        width: '100%',
        marginTop: 15

    },
    formControl: {
        fontFamily: 'iransans',
        width: '100%',
        marginBottom: 15,

    },

    wrapper: {
        marginTop: 15,
        position: 'relative',
    },
    buttonSuccess: {
        fontSize: 18,
        fontWeight: 'bold',
        height: 43,
        width: '100%',

        fontFamily: 'iransans',
        color: '#dadada',
        backgroundColor: green[500],
        '&:hover': {
            backgroundColor: green[700],
        },
    },

    buttonProgress: {
        color: green[500],
        position: 'absolute',
        top: '50%',
        left: '50%',
        marginTop: -12,
        marginLeft: -12,
    },

    iconButton: {
        padding: 10,
        fontSize: 15,
        fontFamily: 'iransans'
    },
    divider: {
        height: 28,
        margin: 4,
    },

    direction: {
        direction: 'rtl',
        width: 150,
        height: 40
    },

    fontright: {
        fontFamily: 'iransans',
        textAlign: 'right',
        marginRight: 10,
        width: 100
    },
    fontleft: {
        fontFamily: 'iransans',
        textAlign: 'right',
        marginLeft: 10
    }

}));


const AgentlistMobile = () => {


    const classes = useStyles();
    const [noContentFoundMessage] = useState("مشاوری با این اسم پیدا نشد");
    const [alertMessage, setAlertMessage] = useState("");
    const [showMessage, setShowMessage] = useState(false);
    const [selectedSectionId, setSelectedSectionId] = useState(1);
    const [drawerState, setDrawerState] = useState(false);
    const [show, setShow] = useState(false);
    const [agentMode, setAgentMode] = useState(true);
    const [user] = useState({
        name: "Robert Johnson",
        email: "robert.johnson@example.com",
        avatar: "https://via.placeholder.com/150x150"
    });
    const [searchUser, setSearchUser] = useState("");
    const [filterOption, setFilterOption] = useState("All contacts");
    const [allContact, setAllContact] = useState(contactsData);
    const [contactList, setContactList] = useState(contactsData);
    const [selectedContacts, setSelectedContacts] = useState(0);
    const [addContactState, setAddContactState] = useState(false);
    const [searchtext, setSearchtext] = useState(null);
    const [openalert, setOpenalert] = useState(false);


    const [dialogclose, setDialogclose] = React.useState(false);


    const [loader, setLoader] = useState(false);
    const [name, setName] = React.useState('');
    const [email, setEmail] = React.useState('');
    const [password, setPassword] = React.useState('');
    const [repassword, setRepassword] = React.useState('');

    const {width} = useSelector(({settings}) => settings);
    // const {agentMode} = useSelector(({auth}) => auth);


    useEffect(() => {

        // var bodyFormData = new FormData();
        // bodyFormData.append('Guest', false);
        getagent()
            .then((response) => {

                //listcontact = response.data.contact;
                debugger;
                setAllContact(response.data.contact);
                setContactList(response.data.contact);
                setShow(true);

            })
            .catch((error) => {


            });


    }, []);


    const ContactSideBar = (user) => {
        return <div className="module-side">
            <div className="module-side-header">
                <div className="module-logo">
                    <i className="zmdi zmdi-account-box mr-4"/>
                    <span><IntlMessages id="chat.contacts"/></span>
                </div>
            </div>

            <div className="module-side-content">
                <CustomScrollbars className="module-side-scroll scrollbar"
                                  style={{height: width >= 1200 ? 'calc(100vh - 200px)' : 'calc(100vh - 80px)'}}>
                    <div className="module-add-task">
                        <Button className="jr-btn btn-block" variant="contained" color="primary" aria-label="add"
                                onClick={onAddContact}>
                            <i className="zmdi zmdi-account-add zmdi-hc-fw"/>
                            <span>Add New Contact</span>
                        </Button>
                    </div>
                    <div className="module-side-nav">
                        <ul className="module-nav">
                            {filterOptions.map(option => <li key={option.id} className="nav-item">
                  <span
                      className={`jr-link ${option.id === selectedSectionId ? 'active' : ''}`} onClick={
                      () => onFilterOptionSelect(option)
                  }>
                    <i className={`zmdi ${option.icon}`}/>
                    <span>{option.name}</span>
                  </span>
                                </li>
                            )}

                        </ul>
                    </div>
                </CustomScrollbars>
            </div>
        </div>

    };

    const onupdate = () => {

        getagent()
            .then((response) => {

                //listcontact = response.data.contact;
                setAllContact(response.data.contact);
                setContactList(response.data.contact);
                setShow(true);

            })
            .catch((error) => {


            });

    };

    const addFavourite = (data) => {
        // setAlertMessage(data.starred ? 'Contact removed as star' : 'Contact marked as star');
        // setShowMessage(true);
        // setContactList(contactList.map((contact) => contact.id === data.id ? {
        //     ...contact,
        //     starred: !data.starred
        // } : contact));
        // setAllContact(allContact.map((contact) => contact.id === data.id ? {
        //     ...contact,
        //     starred: !data.starred
        // } : contact))
    };
    const onContactSelect = (data) => {
        data.selected = !data.selected;
        let updatedSelectedContacts = 0;
        const updatedContactList = contactList.map(contact => {
                if (contact.selected) {
                    updatedSelectedContacts++;
                }
                if (contact.id === data.id) {
                    if (contact.selected) {
                        updatedSelectedContacts++;
                    }
                    return data;
                } else {
                    return contact;
                }
            }
        );
        setSelectedContacts(updatedSelectedContacts);
        setContactList(updatedContactList);
    };


    const onAddContact = () => {
        setAddContactState(true);
    };
    const onContactClose = () => {
        setAddContactState(false)
    };
    const onFilterOptionSelect = (option) => {
        switch (option.name) {
            case 'All contacts': {
                setSelectedSectionId(option.id);
                setFilterOption(option.name);
                setContactList(allContact);
                break;
            }
            case 'Frequently contacted': {
                setSelectedSectionId(option.id);
                setFilterOption(option.name);
                setContactList(allContact.filter((contact) => contact.frequently));
                break;
            }
            case 'Starred contacts': {
                setSelectedSectionId(option.id);
                setFilterOption(option.name);
                setContactList(allContact.filter((contact) => contact.starred));
                break;
            }
            default: {
                setSelectedSectionId(option.id);
                setFilterOption(option.name);
                setContactList(allContact);
            }
        }

    };
    const onSaveContact = (data) => {
        // let isNew = true;
        // const updatedContactList = allContact.map((contact) => {
        //     if (contact.id === data.id) {
        //         isNew = false;
        //         return data
        //     } else {
        //         return contact
        //     }
        // });
        // if (isNew) {
        //     updatedContactList.push(data);
        // }
        // setAlertMessage(isNew ? 'Contact Added Successfully' : 'Contact Updated Successfully');
        // setShowMessage(true);
        // setContactList(updatedContactList);
        // setAllContact(updatedContactList);

        if (password !== '' && repassword !== '') {

            if (password === repassword) {
                setLoader(true);
                var body = new FormData();
                body.append('name', name);
                body.append('email', email);
                body.append('password', password);
                // body.append('Guest', false);

                saveagent(body)
                    .then((response) => {
                        if (response.data.errorCode === 0) {

                            getagent()
                                .then((response) => {

                                    setLoader(false);
                                    setAddContactState(false);
                                    //listcontact = response.data.contact;
                                    setAllContact(response.data.contact);
                                    setContactList(response.data.contact);
                                    setShow(true);
                                    setName('');
                                    setEmail('');
                                    setPassword('');


                                })
                                .catch((error) => {
                                });
                        } else {
                            setLoader(false);
                            setAddContactState(false);
                            alertMessage(response.data.errorDescription);
                            setOpenalert(true);


                        }
                    })
                    .catch((error) => {
                        setLoader(false);
                        setAddContactState(false);
                    })
            }
        }


    };
    const onDeleteContact = (data) => {

        deletedata = data;
        setDialogclose(true);


        // setAlertMessage('Contact Deleted Successfully');
        // setShowMessage(true);
        // setAllContact(allContact.filter((contact) => contact.id !== data.id));
        // setContactList(allContact.filter((contact) => contact.id !== data.id));
    };


    const onDeleteSelectedContact = () => {
        const contacts = allContact.filter((contact) => !contact.selected);
        setAlertMessage('Contact Deleted Successfully');
        setShowMessage(true);
        setAllContact(contacts);
        setContactList(contacts);
        setSelectedContacts(0);
    };

    const filterContact = (userName) => {

        if (userName === '') {
            setContactList(allContact);
        } else {
            const filterContact = allContact.filter((contact) =>
                contact.Name.toLowerCase().indexOf(userName.toLowerCase()) > -1);
            if (filterOption === 'All contacts') {
                setContactList(filterContact);
            } else if (filterOption === 'Frequently contacted') {
                setContactList(filterContact.filter((contact) => contact.frequently));
            } else if (filterOption === 'Starred contacts') {
                setContactList(filterContact.filter((contact) => contact.starred));
            }
        }
    };
    const handleRequestClose = () => {
        setShowMessage(false)
    };
    const getAllContact = () => {
        let contactLists = allContact.map((contact) => contact ? {
            ...contact,
            selected: true
        } : contact);
        setSelectedContacts(contactLists.length);
        setAllContact(contactLists);
        setContactList(contactLists);
    };

    const getUnselectedAllContact = () => {
        let contactLists = allContact.map((contact) => contact ? {
            ...contact,
            selected: false
        } : contact);
        setSelectedContacts(0);
        setAllContact(contactLists);
        setContactList(contactLists);
    };

    const onAllContactSelect = () => {
        const selectAll = selectedContacts < contactList.length;
        if (selectAll) {
            getAllContact();
        } else {
            getUnselectedAllContact();
        }
    };

    const updateContactUser = (evt) => {
        setSearchUser(evt.target.value);
        filterContact(evt.target.value)
    };

    const onToggleDrawer = () => {
        setDrawerState(!drawerState)
    };
    const onsearch = (e) => {

        setSearchtext(e.target.value);
        filterContact(e.target.value);


    };


    const onname = (e) => {
        setName(e.target.value);
    };
    const onemail = (e) => {
        setEmail(e.target.value);
    };
    const onpassword = (e) => {
        setPassword(e.target.value);
    };
    const onrepassword = (e) => {
        setRepassword(e.target.value);
    };

    // const getFilteredHomes =
    //     // homelist.filter(s => s.Name.includes(searchtext))
    //
    //
    //     contactList.filter((data) => {
    //         if (searchtext == null)
    //             return data
    //         else if (data.Name.toLowerCase().includes(searchtext.toLowerCase())) {
    //             return data
    //         }
    //     }).map((data, index) => {
    //         return (
    //             <ProductListItem push={props.history.push} toedit={toedit} key={index} product={data}/>
    //         )
    //     });


    const onClickyes = () => {


        setLoader(true);


        deleteagent(deletedata.id)
            .then((response) => {
                if (response.data.errorCode === 0) {

                    setLoader(false);
                    setDialogclose(false);
                    // setAllContact(allContact.filter((contact) => contact.id !== deletedata.id));
                    setContactList(allContact.filter((contact) => contact.id !== deletedata.id));


                } else {

                    setLoader(false);
                    setDialogclose(false);
                    setAlertMessage(response.data.errorDescription);
                    setOpenalert(true);


                }

            })
            .catch((error) => {


            })


    };
    const onClickcancel = () => {

        setDialogclose(false);


    };


    return (
         <div className="app-wrapper" style={{height: '100%'}}>

            {/*<Header title="کارپرداز ها " back={false}/>*/}

            {agentMode ?

                <div style={{height: '100%', paddingTop: '70px'}} className="app-module animated slideInUpTiny animation-duration-3">

                    {/*<div className="d-block d-xl-none">*/}
                    {/*<Drawer*/}
                    {/*open={drawerState}*/}
                    {/*onClose={onToggleDrawer}>*/}
                    {/*{ContactSideBar(user)}*/}
                    {/*</Drawer>*/}
                    {/*</div>*/}
                    {/*<div className="app-module-sidenav d-none d-xl-flex">*/}
                    {/*{ContactSideBar(user)}*/}
                    {/*</div>*/}

                    <div className="card product-item-vertical hoverable animation flipInX  "
                         style={{width: '100%', padding: 10}}>

                        <div className="row" style={{marginTop: 10}}>


                            <div className="d-flex col-sm-12 mb-sm-4 mb-4 d-md-none justify-content-end ">

                                <Button onClick={onAddContact} style={{color: "#ffffff"}} className={classes.buttonfull}
                                        variant="outlined"
                                >
                                    ثبت مشاور جدید
                                </Button>

                            </div>


                            <div className="col-md-4 col-12 mt-sm-2 mb-sm-2 mt-md-0 mb-md-0 ">
                                <TextField
                                    onChange={e => onsearch(e)}
                                    placeholder="جستجو در نام مشاور"
                                    style={{width: '100%', fontFamily: 'iransans'}}
                                    id="outlined-basic" variant="outlined" InputLabelProps={{
                                    style: {height: 40, width: '100%', fontFamily: 'iransans'},
                                    shrink: false,
                                }} InputProps={{style: {height: 40, width: '100%', fontFamily: 'iransans'}}}/>

                            </div>


                            <div className="col-md-4 col-12">

                                {/*<div className="module-box-header">*/}
                                {/*<IconButton className="drawer-btn d-block d-xl-none" aria-label="Menu"*/}
                                {/*onClick={onToggleDrawer}>*/}
                                {/*<i className="zmdi zmdi-menu"/>*/}
                                {/*</IconButton>*/}
                                {/*<AppModuleHeader placeholder="Search contact" notification={false} apps={false}*/}
                                {/*user={user}*/}
                                {/*onChange={updateContactUser}*/}
                                {/*value={searchUser}/>*/}


                                {/*</div>*/}
                            </div>

                            <div className="col-md-4 col-12 d-none d-md-flex justify-content-end">
                                {/*<div className="module-add-task">*/}
                                {/*<Button className="jr-btn btn-block" variant="contained" color="primary"*/}
                                {/*aria-label="add"*/}
                                {/*onClick={onAddContact}>*/}
                                {/*<i className="zmdi zmdi-account-add zmdi-hc-fw"/>*/}
                                {/*<span>Add New Contact</span>*/}
                                {/*</Button>*/}

                                <Button onClick={onAddContact} style={{color: "#ffffff"}} className={classes.button}
                                        variant="outlined"
                                >
                                    ثبت مشاور جدید
                                </Button>

                                {/*</div>*/}
                            </div>
                        </div>

                        <div className="module-box-content">
                            <div className="module-box-topbar">
                                {/*<Checkbox color="primary"*/}
                                {/*indeterminate={selectedContacts > 0 && selectedContacts < contactList.length}*/}
                                {/*checked={selectedContacts > 0}*/}
                                {/*onChange={onAllContactSelect}*/}
                                {/*value="SelectMail"/>*/}
                                {selectedContacts > 0 &&
                                <IconButton className="icon-btn"
                                            onClick={onDeleteSelectedContact}>
                                    <i className="zmdi zmdi-delete"/>
                                </IconButton>}
                            </div>
                            {show ?
                                <div>
                                    {contactList.length === 0 ?
                                        <div style={{marginTop: 15,marginBottom:15}}
                                             className="h-100 d-flex align-items-center justify-content-center iran-font">
                                            {noContentFoundMessage}
                                        </div>
                                        : <ContactListAgent
                                            onupdate={onupdate}
                                            contactList={contactList}
                                            addFavourite={addFavourite}
                                            onContactSelect={onContactSelect}
                                            onDeleteContact={onDeleteContact}
                                            onSaveContact={onSaveContact}/>
                                    }

                                    {/*<CustomScrollbars className="module-list-scroll scrollbar"*/}
                                    {/*style={{height: width >= 1200 ? 'calc(100vh - 259px)' : 'calc(100vh - 240px)'}}>*/}

                                    {/*</CustomScrollbars>*/}

                                </div>
                                :
                                <div style={{
                                    height: 250, display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center'
                                }}>

                                    <CircularProgress size={24} className={classes.buttonProgress}/>
                                </div>
                            }
                        </div>
                    </div>
                </div>

                :
                <div style={{height: '100%', paddingTop: '70px'}}
                     className="animated slideInUpTiny animation-duration-3 d-flex flex-column ">

                    <div>

                        <div style={{
                            textAlign: 'center',
                            marginTop: 50,
                            fontSize: 15,
                            fontFamily: 'iransans',
                            fontWeight: 'bold'
                        }}>
                            <div>
                                شما اجازه دسترسی به این صفحه را ندارید ...
                            </div>
                        </div>

                    </div>

                </div>
            }


            <Dialog open={addContactState} onClose={onContactClose} className="slideInUpTiny">
                {/*<DialogTitle>*/}
                {/*<div style={{fontFamily: 'iransans'}}>*/}
                {/*ثبت مخاطب جدید*/}
                {/*</div>*/}

                {/*</DialogTitle>*/}

                <div style={{
                    display: 'flex', justifyContent: 'space-between',
                    alignItems: 'center', width: '100%'
                }}>

                    <div style={{margin: 10, fontSize: 15, fontFamily: 'iransans'}}>
                        ثبت مشاور جدید
                    </div>

                    <IconButton onClick={onContactClose} aria-label="Close">
                        <CloseIcon/>
                    </IconButton>


                </div>


                <DialogContent>
                    <div style={{
                        display: 'flex', justifyContent: 'start', flex: 1,
                        alignItems: 'start', flexDirection: 'column', width: 270,
                    }}>

                        <TextField
                            InputProps={{
                                classes: {
                                    root: classes.input,
                                    error: classes.input
                                },
                            }}
                            InputLabelProps={{
                                classes: {
                                    root: classes.input,
                                    error: classes.input
                                }
                            }}
                            fullWidth
                            value={name}
                            onChange={onname}
                            id="name" label="نام و نام خانوادگی"
                            type="text" variant="outlined"
                        />
                        <TextField
                            InputProps={{
                                classes: {
                                    root: classes.input,
                                    error: classes.input
                                },
                            }}
                            InputLabelProps={{
                                classes: {
                                    root: classes.input,
                                    error: classes.input
                                }
                            }}
                            onChange={onemail}
                            style={{marginTop: 10}}
                            fullWidth
                            value={email}
                            pattern="[0-9]*"
                            id="name" label="ایمیل"
                            variant="outlined"
                        />
                        <TextField
                            InputProps={{
                                classes: {
                                    root: classes.input,
                                    error: classes.input
                                },
                            }}
                            InputLabelProps={{
                                classes: {
                                    root: classes.input,
                                    error: classes.input
                                }
                            }}
                            onChange={onpassword}
                            style={{marginTop: 10}}
                            fullWidth
                            value={password}
                            pattern="[0-9]*"
                            type="password"
                            id="name" label="کلمه عبور"
                            variant="outlined"
                        />
                        <TextField
                            InputProps={{
                                classes: {
                                    root: classes.input,
                                    error: classes.input
                                },
                            }}
                            InputLabelProps={{
                                classes: {
                                    root: classes.input,
                                    error: classes.input
                                }
                            }}
                            onChange={onrepassword}
                            style={{marginTop: 10}}
                            fullWidth
                            value={repassword}
                            type="password"
                            pattern="[0-9]*"
                            id="name" label="تکرار کلمه عبور"
                            variant="outlined"
                        />

                        <div className="d-flex align-items-center" style={{width: '100%'}}>

                            <Button onClick={onSaveContact} disabled={loader} variant="contained"

                                    style={{
                                        width: '100%',
                                        height: 40,
                                         backgroundColor:'#3f51b5',
                                        marginTop: 15,
                                        marginBottom: 15,
                                        flex: 1,
                                        display: 'flex',
                                        flexDirection: 'column',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        border: '1px solid ',
                                    }}
                                    className="iran-font">
                                <div style={{fontSize: 15, color: '#fff', fontWeight: 500}}>ثبت</div>
                                {loader &&
                                <CircularProgress size={24} className={classes.buttonProgress}/>}
                            </Button>


                        </div>


                    </div>


                </DialogContent>


                {/*<DialogActions>*/}
                {/*<Button onClick={onContactClose} color="secondary" style={{fontFamily: 'iransans'}}>*/}
                {/*لغو*/}
                {/*</Button>*/}
                {/*<Button onClick={onContactSave} color="primary" style={{fontFamily: 'iransans'}}>*/}
                {/*ثبت*/}
                {/*</Button>*/}
                {/*</DialogActions>*/}
            </Dialog>


            <DialogClose open={dialogclose} title='حذف مخاطب' body='آیا از حذف این مخاطب اطمینان دارید؟' loader={loader}
                         yes={onClickyes} cancel={onClickcancel}/>


            {/*<AddContact open={addContactState} contact={{*/}
            {/*'id': contactId++,*/}
            {/*'name': '',*/}
            {/*'thumb': '',*/}
            {/*'email': '',*/}
            {/*'phone': '',*/}
            {/*'designation': '',*/}
            {/*'selected': false,*/}
            {/*'starred': false,*/}
            {/*'frequently': false,*/}
            {/*}} onSaveContact={onSaveContact}*/}
            {/*onContactClose={onContactClose} onDeleteContact={onDeleteContact}/>*/}

            <Snackbar open={openalert} autoHideDuration={3000} onClose={() => setOpenalert(false)}>
                <Alert style={{fontFamily: 'iransans'}} severity="error">
                    {alertMessage}
                </Alert>
            </Snackbar>


            <Snackbar
                anchorOrigin={{vertical: 'bottom', horizontal: 'center'}}
                open={showMessage}
                autoHideDuration={3000}
                onClose={handleRequestClose}
                ContentProps={{
                    'aria-describedby': 'message-id',
                }}
                message={<span id="message-id">{alertMessage}</span>}
            /></div>
    )
};

export default AgentlistMobile;






